import { render, staticRenderFns } from "./viewMsg.vue?vue&type=template&id=74ee36df"
import script from "./viewMsg.vue?vue&type=script&lang=js"
export * from "./viewMsg.vue?vue&type=script&lang=js"
import style0 from "./viewMsg.vue?vue&type=style&index=0&id=74ee36df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports